// extracted by mini-css-extract-plugin
export default {"closing-report-table-modal":"closing-report-table-modal___btvE9","layout":"layout___hf_D5","content":"content___PzJ3n","footer":"footer___TtgFW"};